import{css as r}from"lit";var o=r`:host{cursor:pointer}`;export default o;
